export function useScrollToTop(_ref: unknown) {}
